import templateUrl from './address-template.html';

export const addressTemplateComponent = {
	bindings: {
		details: '<',
		disableAddress: '@',
		isRequired: '@',
		label: '@',
		onAddressChange: '&'
	},
	templateUrl,
	controller: class AddressTemplateComponent {
		constructor($timeout, $parse) {
			"ngInject";
			this.$parse = $parse;
			this.$timeout = $timeout;
		}

		$onInit() {
			this.place = {};
			this.addressError = false;
			this.showMapLightbox = false;
			this._isRequired = this.$parse(this.isRequired || 'true')(true);
			this._disableAddress = this.$parse(this.disableAddress || 'false')(false);
			if (this.details && !this.details.addressLine1) {
				this.details = this.resetDetails();
			} else {
				this._isRequired = false;
			}
		}

		resetDetails() {
			return {
				addressLine1: "",
				addressLine2: "",
				cityName: "",
				stateName: "",
				stateCode: "",
				latitude: "",
				longitude: "",
				zipcode: "",
				status: -1
			};
		}

		getLocationDetails(details) {
			this.$timeout(() => {
				this.addressError = details.isError;
				this._isRequired = details.isError;
				this.details = details;
				this.onAddressChange({
					$event: this.details
				});
			});
		}

		showMap() {
			if (!this._disableAddress) {
				this.showMapLightbox = !this.showMapLightbox;
			}
		}

		$onChanges(changes) {
			if (changes.disableAddress) {
				this._disableAddress = this.$parse(changes.disableAddress.currentValue || 'false')(false);
			}
			if (changes && changes.isRequired) {
				this._isRequired = this.$parse(this.isRequired || 'true')(true);
			}
			if (changes.details && changes.details.currentValue) {
				this._isRequired = (changes.details.currentValue.addressLine1 && changes.details.currentValue.stateName && changes.details.currentValue.cityName) ? false : true;
			}
		}
	}
}


// WEBPACK FOOTER //
// ./src/app/common/components/address-template/address-template.component.js